import api from "./axiosInstance";

export const ProductAPI = {
  async getProductById(uniqueId: string) {
    const response = await api.get(`/parts/${uniqueId}`);
    return response.data;
  },
  async getProductPrices(uniqueId: string) {
    const anonymousId = localStorage.getItem('anonymousId');
    const response = await api.get(`/parts/${uniqueId}/prices${anonymousId ? `?anonymousId=${anonymousId}` : ''}`);
    return response.data;
  },
  async getPopularProducts(limit: number = 5) {
    const response = await api.get(`/parts/popular?limit=${limit}`);
    return response.data;
  }
};